import { rgb, PageSizes, StandardFonts } from 'pdf-lib'
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf'
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf'
import fontkit from '@pdf-lib/fontkit'

import { createPDFDocument, customDrawText, getFontArrayBuffer } from './pdf_create'
import { drawTextInBox, X_ALIGN_CENTER, X_ALIGN_RIGHT } from './pdfUtil/drawTextInBox'
import { getDisplayOriginWithOther, getDisplaySize } from '../../utils/Items'
import { postMarketPriceSearchInfoListAPI, postMarketPriceSearchTableInfoListAPI } from '../../http/api/MarketPriceAPI'
import { filterPartition, getOutputDestination, getOutputShippingDate, getPrintPages, getProductPartitionList } from '../../utils/orderForm'
import { getAmPmHour } from '../../utils/utils'

export const getGeneralOrderFormPageParameter = (width, height, fonts, shops, destinations, pdfSetting) => {

  const {productTypePartition, unitPrice, deadlineHourOutput, orderQuantityOutput, skipOrderUnit, isSendingAgain, printPageStr, outputPrice, asSendingLabel} = pdfSetting;

  const margin = 20

  const headerHeight = 40
  const tableStart_y = height - margin - headerHeight

  const footerHeight = 22
  const tableEnd_y = margin + footerHeight

  const rowNumber = 41
  const columnNumber = 3

  const rowHeight = (tableStart_y - tableEnd_y) / (rowNumber + 1);  
  const tableHeaderHeight = rowHeight;

  const tableDataStart_y = tableStart_y - tableHeaderHeight;
  const columnWidth = (width - 2 * margin) / columnNumber
  
  let nameColumnLeft, placeColumnLeft, sizeColumnLeft, priceColumnLeft, orderUnitColumnLeft = 0;

  if (!outputPrice) {
    placeColumnLeft = columnWidth * 0.25;
    sizeColumnLeft = columnWidth * 0.51;
    priceColumnLeft = columnWidth * 0.7;
    orderUnitColumnLeft = columnWidth * 0.7;
  } else if (orderQuantityOutput) {
    placeColumnLeft = columnWidth * 0.25;
    sizeColumnLeft = columnWidth * 0.42;
    priceColumnLeft = columnWidth * 0.70;
    orderUnitColumnLeft = columnWidth * 0.85;
  } else {
    placeColumnLeft = columnWidth * 0.29;
    sizeColumnLeft = columnWidth * 0.5;
    priceColumnLeft = columnWidth * 0.81;
    orderUnitColumnLeft = columnWidth * 1.00;
  }  

  return {
    ...pdfSetting,
    width,
    height,
    margin,
    headerHeight,
    tableStart_y ,  
    footerHeight ,
    tableEnd_y ,  
    rowNumber ,
    columnNumber ,
    rowHeight,
    tableHeaderHeight,
    tableDataStart_y,
    columnWidth ,
    nameColumnLeft ,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft ,
    orderUnitColumnLeft,
    fonts,
    productTypePartition,
    deadlineHourOutput,
    orderQuantityOutput,
    skipOrderUnit,
    shops,
    destinations,
    unitPrice,
    isSendingAgain,
    printPageStr
  }
}

// 価格表　ヘッダ部分作成
export const createGeneralOrderFormHeader = (page, title, destination, shippingDateInfo, pageParameter) => {

  const {width, height, margin, tableStart_y, fonts, isSendingAgain} = pageParameter

  const shippingDateStr = getOutputShippingDate(shippingDateInfo.shippingDateFrom, shippingDateInfo.shippingDateTo);
  
  const headerStart_y = height - margin;

  // 担当者
  if(pageParameter.directorEmployee){
    customDrawText(page, `担当者：${pageParameter.directorEmployee}`, {
      x: margin,
      y: headerStart_y,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    });}  

  // 表タイトル
  customDrawText(page,'御取引先各位', {
    x: margin,
    y: headerStart_y - 15,
    size: 15,
    font: fonts.mincho_bold_font,
    color: rgb(0, 0, 0),
  })

  page.drawLine({
    start: { x: margin, y: headerStart_y - 20 },
    end: { x: margin + 90, y: headerStart_y - 20 },
    thickness : 1,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  // 再送
  if (isSendingAgain) {
    drawTextInBox(
      page, 
      "再送",
      {x1: width - margin - 45, x2: width - margin, y1: headerStart_y + 3, y2: headerStart_y - 22},
      {xAlign: X_ALIGN_RIGHT, font: fonts.mincho_bold_font, size: 20}
    )

    page.drawLine({
      start: { x: width - margin - 45, y: headerStart_y - 22 },
      end: { x:width - margin, y: headerStart_y - 22 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawLine({
      start: { x: width - margin - 45, y: headerStart_y - 24 },
      end: { x:width - margin , y: headerStart_y - 24 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }

  customDrawText(page,destination, {
    x: margin,
    y: headerStart_y - 35,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, title, {
    x: width / 2 - title.length * 9,
    y: headerStart_y - 35,
    size: 18,
    font: fonts.mincho_bold_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, '納品日：' + shippingDateStr, {
    x: width - margin - (shippingDateInfo.shippingDateTo ? 250 : 140),
    y: headerStart_y - 35,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
}

// 価格表の骨格作成
export const createGeneralOrderFormTableBones = (page, pageParameter) => {

  const {
    width,
    margin,
    tableStart_y,
    tableEnd_y,
    rowNumber,
    columnNumber,
    rowHeight,
    columnWidth,
    placeColumnLeft,
    sizeColumnLeft,
    priceColumnLeft,
    orderUnitColumnLeft,
    fonts,
    orderQuantityOutput,
    unitPrice,
    outputPrice,
    asSendingLabel
  } = pageParameter

  let textInBoxOption = {
    font: fonts.mincho_font,
    size: 10,
    xPadding: 1,
    yPadding: 0,
    xAlign: X_ALIGN_CENTER
  };

  // 横罫線
  Array.from(new Array(rowNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: margin, y: tableStart_y - rowHeight * (index + 1)},
      end: { x: width - margin, y: tableStart_y - rowHeight * (index + 1)},
      thickness : 0.5,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  })

  page.drawLine({
    start: { x: margin, y: tableStart_y },
    end: { x: width - margin, y: tableStart_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawLine({
    start: { x: margin, y: tableStart_y - rowHeight * (rowNumber + 1) },
    end: { x: width - margin, y: tableStart_y - rowHeight *  (rowNumber + 1) },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  // 縦罫線と表ヘッダ
  Array.from(new Array(columnNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: margin + columnWidth * index, y: tableStart_y},
      end: { x: margin + columnWidth * index, y: tableEnd_y},
      thickness : 2,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // customDrawText(page,'商品名', {
    //   x: margin + columnWidth * index + 2,
    //   y: tableStart_y - rowHeight / 2 - 4,
    //   size: 10,
    //   font: fonts.mincho_font,
    //   color: rgb(0, 0, 0),
    // })
    drawTextInBox(page, '商品名', {
      x1: margin + columnWidth * index,
      x2: margin + columnWidth * index + placeColumnLeft,
      y1: tableStart_y,
      y2: tableStart_y - rowHeight + 2
    }, textInBoxOption)
    
    page.drawLine({
      start: { x: margin + columnWidth * index + placeColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + placeColumnLeft, y: tableEnd_y},
      thickness : 0.5,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // customDrawText(page,'産地', {
    //   x: margin + columnWidth * index + placeColumnLeft + 2,
    //   y: tableStart_y - rowHeight / 2 - 4,
    //   size: 10,
    //   font: fonts.mincho_font,
    //   color: rgb(0, 0, 0),
    // })
    drawTextInBox(page, '産地', {
      x1: margin + columnWidth * index + placeColumnLeft,
      x2: margin + columnWidth * index + sizeColumnLeft,
      y1: tableStart_y,
      y2: tableStart_y - rowHeight + 2
    }, textInBoxOption)

    page.drawLine({
      start: { x: margin + columnWidth * index + sizeColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + sizeColumnLeft, y: tableEnd_y},
      thickness : 0.5,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // customDrawText(page,'規格', {
    //   x: margin + columnWidth * index + sizeColumnLeft + 2,
    //   y: tableStart_y - rowHeight / 2 - 4,
    //   size: 10,
    //   font: fonts.mincho_font,
    //   color: rgb(0, 0, 0),
    // })
    drawTextInBox(page, '規格', {
      x1: margin + columnWidth * index + sizeColumnLeft,
      x2: margin + columnWidth * index + priceColumnLeft,
      y1: tableStart_y,
      y2: tableStart_y - rowHeight + 2
    }, textInBoxOption)

    if (outputPrice) {
      page.drawLine({
        start: { x: margin + columnWidth * index + priceColumnLeft, y: tableStart_y},
        end: { x: margin + columnWidth * index + priceColumnLeft, y: tableEnd_y},
        thickness : 0.5,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      drawTextInBox(
        page,
        (unitPrice === 2 ? 'キロ単価' : '価格'),
        {
          x1: margin + columnWidth * index + priceColumnLeft,
          x2: margin + columnWidth * index + orderUnitColumnLeft,
          y1: tableStart_y,
          y2: tableStart_y - rowHeight + 2
        },
        textInBoxOption    
      )
    }

    page.drawLine({
      start: { x: margin + columnWidth * index + orderUnitColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + orderUnitColumnLeft, y: tableEnd_y},
      thickness : 0.5,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    if (asSendingLabel) {

      page.drawLine({
        start: { x: margin + columnWidth * index + orderUnitColumnLeft + 1.5, y: tableStart_y},
        end: { x: margin + columnWidth * index + orderUnitColumnLeft + 1.5 , y: tableEnd_y},
        thickness : 0.5,
        color: rgb(0, 0, 0),
        opacity : 1
      })
      
      drawTextInBox(page, '納品数', {
        x1: margin + columnWidth * index + orderUnitColumnLeft,
        x2: margin + columnWidth * index + columnWidth,
        y1: tableStart_y,
        y2: tableStart_y - rowHeight + 2
      }, textInBoxOption) 
      
    } else if (orderQuantityOutput) {

      page.drawLine({
        start: { x: margin + columnWidth * index + orderUnitColumnLeft + 1.5, y: tableStart_y},
        end: { x: margin + columnWidth * index + orderUnitColumnLeft + 1.5 , y: tableEnd_y},
        thickness : 0.5,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      // customDrawText(page,'注文数', {
      //   x: margin + columnWidth * index + orderUnitColumnLeft + 2,
      //   y: tableStart_y - rowHeight / 2 - 4,
      //   size: 10,
      //   font: fonts.mincho_font,
      //   color: rgb(0, 0, 0),
      // })
      drawTextInBox(page, '注文数', {
        x1: margin + columnWidth * index + orderUnitColumnLeft,
        x2: margin + columnWidth * index + columnWidth,
        y1: tableStart_y,
        y2: tableStart_y - rowHeight + 2
      }, textInBoxOption)         
    }
  })

  page.drawLine({
    start: { x: width - margin, y: tableStart_y},
    end: { x: width - margin, y: tableEnd_y},
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })
}

export const outputGeneralOrderFormTableProductData = (page, pageParameter, rowIndex, columnIndex, outputData) => {

  const {
    margin,
    rowHeight ,
    columnWidth ,
    placeColumnLeft ,
    sizeColumnLeft ,
    orderUnitColumnLeft,
    priceColumnLeft,
    fonts,
    tableDataStart_y, 
    orderQuantityOutput,
    skipOrderUnit,
    outputPrice
  } = pageParameter;

  const {
    name,
    origin,
    size,
    price,
    unit,
    outputAsFirstOfType,
    isShortage
  } = outputData;

  const dataStart_x = margin + columnWidth * columnIndex

  const textBox_y1 = tableDataStart_y - rowHeight * rowIndex;
  const textBox_y2 = tableDataStart_y - rowHeight * (rowIndex + 1) + 2

  let outputOrigin = origin ? origin : "";
  let outputUnit = unit ? unit: "";
  let outputSize = size ? size: "";

  let textInBoxOption = {
    font: fonts.mincho_font,
    size: 10,
    xPadding: 1,
    yPadding: 0,
    xAlign: X_ALIGN_CENTER
  };

  if (outputAsFirstOfType) {
      page.drawLine({
      start: { x: dataStart_x, y: tableDataStart_y - rowHeight * rowIndex - 1.5 },
      end: { x: dataStart_x + columnWidth,  y: tableDataStart_y - rowHeight * rowIndex - 1.5},
      thickness : 0.5,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }

  // 商品名
  drawTextInBox(
    page,
    name,
    {
      x1: dataStart_x,
      x2: dataStart_x + placeColumnLeft,
      y1: textBox_y1,
      y2: textBox_y2
    },
    {...textInBoxOption, font: fonts.mincho_bold_font}    
  )

  // 産地
  drawTextInBox(
    page,
    outputOrigin,
    {
      x1: dataStart_x + placeColumnLeft,
      x2: dataStart_x + sizeColumnLeft,
      y1: textBox_y1,
      y2: textBox_y2
    },
    textInBoxOption  
  )

  // 規格
  drawTextInBox(
    page,
    outputSize,
    {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: textBox_y1,
      y2: textBox_y2
    },
    textInBoxOption  
  )

  // 価格
  if (outputPrice) {
    drawTextInBox(
      page,
      isShortage ? "-" : price.toLocaleString(),
      {
        x1: dataStart_x + priceColumnLeft,
        x2: dataStart_x + orderUnitColumnLeft,
        y1: textBox_y1,
        y2: textBox_y2
      },
      {...textInBoxOption, font: fonts.helvetica_bold_font, xAlign: X_ALIGN_RIGHT, size: 11, shrink: false}
    )
  }

  // 発注単位
  if (orderQuantityOutput && !skipOrderUnit) {
    drawTextInBox(
      page,
      outputUnit,
      {
        x1: dataStart_x + orderUnitColumnLeft,
        x2: dataStart_x + columnWidth,
        y1: textBox_y1,
        y2: textBox_y2
      },
      {...textInBoxOption, xAlign: X_ALIGN_RIGHT}
    )
  }
}

// フッター
export const createGeneralOrderFormFooter = (page, pageParameter, marketPriceInfo) => {
  const {
    footerHeight,
    width,
    margin,
    fonts,
    deadlineHourOutput
  } = pageParameter

  const { orderDeadlineHour } = marketPriceInfo;

  const orderDeadline = getAmPmHour(orderDeadlineHour);

  // 発注時間注意
  if (deadlineHourOutput) {
    customDrawText(page,`※発注は、${orderDeadline.amPm}`, {
      x: margin,
      y: margin + 4,
      size: 12,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  
    customDrawText(page,`${orderDeadline.hour}時`, {
      x: margin + 90,
      y: margin + 4,
      size: 15,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  
    //時間は２数字ならスペースを開ける
    const orderDeadlineHourSpaceAddition = orderDeadline.hour.toString().length > 1 ? 10 : 0;
    customDrawText(page,'までにお願い致します。', {
      x: margin + 115 + orderDeadlineHourSpaceAddition,
      y: margin + 4,
      size: 12,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  
  }
  
  // 青果連絡先
  customDrawText(page, '丸伊伊那青果(株)', {
    x: width - margin - 180,
    y: margin + 4,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'TEL: 0265-74-5588', {
    x: width - margin - 80,
    y: margin + 10,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'FAX: 0265-73-7210', {
    x: width - margin - 80,
    y: margin,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

}

// 価格表(横)PDF文書作成
async function createGeneralOrderFormPDFDocumentInfo(
      priceInfoList,
      shops,
      destinations,
      isSample,
      shippingDateInfo,
      pdfSetting,
      marketPriceInfo,
  ) {

  const pdfDoc = await createPDFDocument()
  
  //埋込フォント使用
  pdfDoc.registerFontkit(fontkit);
  
  //日本語フォント読込
  const genminchoArrayBuffer = await getFontArrayBuffer(genmincho);
  const genminchoBoldArrayBuffer = await getFontArrayBuffer(genmincho_bold);

  const mincho_font = await pdfDoc.embedFont(genminchoArrayBuffer);
  const mincho_bold_font = await pdfDoc.embedFont(genminchoBoldArrayBuffer);
  const helvetica_bold_font =  await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const [ height, width ] = PageSizes.A4

  const pageParameter = getGeneralOrderFormPageParameter(width, height, {mincho_font, mincho_bold_font, helvetica_bold_font}, shops, destinations, pdfSetting);
  let {rowNumber, columnNumber, shopSummary, productTypePartition, destinationOutputCd} = pageParameter  
  
  // ページ数の判定
  let productPartitionList = getProductPartitionList(priceInfoList, productTypePartition, rowNumber)

  let columnCount = productPartitionList
      .map((productPartition) => Math.ceil(productPartition.length / rowNumber))
      .reduce((prevCnt, thisCnt) => prevCnt + thisCnt, 0);

  let pageCount = Math.ceil(columnCount / columnNumber);

  // ページの生成
  let pages = Array.from(new Array(pageCount)).map((_) => {
    let page = pdfDoc.addPage([width, height]);
    createGeneralOrderFormTableBones(page, pageParameter);    
    createGeneralOrderFormFooter(page, pageParameter, marketPriceInfo);
    return page;
  });

  var lastName = "";
  var lastOrigin = "";
  var lastPriceDetailTypeId = 0;

  var totalDataIndex = 0;

  productPartitionList.forEach((dataList) => {
    if (dataList.length === 0) {
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber
    
    dataList.forEach((data, index) => {

      let rowIndex = totalDataIndex % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      let displayOrigin = getDisplayOriginWithOther(data.origin, data.isOriginOther);

      let outputAsFirstOfType
        = !productTypePartition
          && (data.priceDetailTypeId !== lastPriceDetailTypeId)
          && totalDataIndex > 0;

      if (index % rowNumber === 0 || outputAsFirstOfType) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        ...data,
        name: (lastName === data.productName ? "〃" : data.productName),
        origin: (lastName === data.productName && lastOrigin === displayOrigin ? "〃" : displayOrigin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.isShortage ? "-" : data.price,
        unit: data.orderingUnit,
        outputAsFirstOfType: outputAsFirstOfType
      }

      outputGeneralOrderFormTableProductData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);

      lastName = data.productName;
      lastOrigin = displayOrigin;
      lastPriceDetailTypeId = data.priceDetailTypeId;

      totalDataIndex += 1;
    })
  })

  pdfDoc.setCreator("丸伊伊那青果　事務担当");
  
  return await Promise.all((isSample ? [{customerName:marketPriceInfo.marketPriceName,shopName:""}] : destinations).map(async (destinationInfo) => {
    let newPdfDoc = await pdfDoc.copy();
    
    //埋込フォント使用
    newPdfDoc.registerFontkit(fontkit);

    let newFonts = {
      mincho_font: await newPdfDoc.embedFont(genminchoArrayBuffer),
      mincho_bold_font: await newPdfDoc.embedFont(genminchoBoldArrayBuffer),
      helvetica_bold_font: await newPdfDoc.embedFont(StandardFonts.HelveticaBold)
    }
    let newPageParameter = {...pageParameter, fonts: newFonts};

    return await createGeneralOrderFormPDFFromDocument(
      newPdfDoc,
      "市況価格表",
      getDestinationOutputName(destinationInfo, shopSummary, destinationOutputCd),
      shippingDateInfo,
      newPageParameter
    )
  }))

}

async function createGeneralOrderFormPDFFromDocument(pdfDoc, title, destinationName, shippingDateInfo, pageParameter) {
  pdfDoc.getPages().forEach((page) => createGeneralOrderFormHeader(page, title, destinationName, shippingDateInfo, pageParameter))
  
  // 選択されたページに対する余計なページを削除
  const printPages = getPrintPages(pageParameter.printPageStr, pdfDoc.getPageCount());

  const deletePages
    = Array.from(new Array(pdfDoc.getPageCount()))
      .map((_, pageIndex) => pageIndex)
      .filter((pageIndex) => !printPages.includes(pageIndex + 1))
      .reverse();

  deletePages.forEach((pageIndex) => {
    pdfDoc.removePage(pageIndex);
  });
  
  return await pdfDoc.save();
}


//export async function createVerticalOrderFormPDF(customerInfo, shopNames, destinationNames, shippingDate, pdfSetting) {
export async function createGeneralOrderFormPDF(
  marketPriceId, shops, destinations, isSample, shippingDateInfo, pdfSetting, marketPriceHistoryDate = null
) {
  let marketPriceResponse = await postMarketPriceSearchTableInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfo = marketPriceResponse.marketPriceTableInfoList[0];
  let res = await postMarketPriceSearchInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfoList = res.marketPriceInfoList
                .filter((data) => data.isCustomerOrder)
                .map((data)=>({...data, price: data.marketPrice}));

  return await createGeneralOrderFormPDFDocumentInfo(
    marketPriceInfoList,
    shops, 
    destinations,
    isSample,
    shippingDateInfo,
    pdfSetting,
    marketPriceInfo
  );
 
}

// あて名取得
const getDestinationOutputName = (destinationInfo, shopSummary, outputCd) => {
  if (outputCd == 2) {
    return "";
  }
  if (outputCd == 3) {
    return "店名 : 　　　　　　　　　　　　　　　様";
  }

  return getOutputDestination(destinationInfo, shopSummary, false);

}
